import { LinkSquare16Regular as LinkIcon } from "@fluentui/react-icons";

interface ExternalLinkProps {
  url: string;
  label: string;
}

function ExternalLink({ url, label }: ExternalLinkProps) {
  const handleClick = () => {
    window.open(url, "_blank");
  };

  return (
    <div
      onClick={handleClick}
      className=" space-x-1 cursor-pointer text-blue-400 flex flex-row items-center h-[42px]"
    >
      <span className="hover:underline">{label}</span>
      <LinkIcon />
    </div>
  );
}

export default ExternalLink;
